import styled from 'styled-components';

export const Title = styled.span`
  color: ${(props) => props.tema.primaryColor};
  font-size: 24px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 13px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const TextBold = styled.span`
  font-weight: bold;
  transition: 0.3s;
`;

export const BodyWrapper = styled.div`
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  width: 100%;
  padding: 8px;

  max-height: calc(100vh - 332px);
  .inputStyle {
    margin-top: 12px;
    margin-bottom: 16px;
    height: 40px;
  }

  .MuiOutlinedInput-notchedOutline {
    border: 2px solid #d1d1d1;
  }

  box-sizing: border-box;
  @media (max-width: 768px) {
    width: 100%;

    > * {
      display: block !important;
    }
  }

  .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: #ba122b;
  }
`;

export const ModalWrapper = styled.div`
  border: 2px solid #d1d1d1;
  border-radius: 10px;
  position: relative;
  background: #fff;
  padding: 32px 48px;
  width: 640px;
  height: fit-content;
  box-sizing: border-box;
  margin: auto;
  color: #4d4d4d;

  * {
    box-sizing: border-box;
  }
  overflow: auto;

  @media (max-width: 768px) {
    padding: 24px 32px;
    width: 100%;

    overflow: auto;
  }
`;

export const FooterWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  > div {
    gap: 36px;
  }
  @media (max-width: 768px) {
    > div {
      flex-direction: column;
      align-items: end;
      width: 100%;
      gap: 0;
    }
  }
`;

export const ValueSectionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px auto;
  color: ${(props) => props.tema.primaryColor};

  .totalLabel {
    font-size: 20px;
    margin-right: 8px;
    display: block;
  }

  .totalValue {
    font-size: 30px;
    font-weight: bold;
  }

  .portion {
    font-size: 14px;
    text-align: end;
    display: block;
  }
`;
